var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "Loading",
            {
              attrs: {
                visible: _vm.loading,
                message: "Caricamento distinta...",
                templateType: _vm.loadTemplateCorrente,
              },
            },
            [
              _c(
                "div",
                [
                  _vm.distinta && _vm.distinta != null
                    ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                        _vm.distinta.eliminataDaAs400
                          ? _c("div", [
                              _vm._v(
                                " La distinta è stata eliminata da As400 "
                              ),
                            ])
                          : _c(
                              "div",
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs10: "", "offset-xs1": "" } },
                                  [
                                    _c(
                                      "v-card",
                                      [
                                        _c(
                                          "v-card-text",
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "headline mb-0",
                                                      },
                                                      [
                                                        _vm._v("MODELLO: "),
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.distinta
                                                                .idModello
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                _vm.distinta
                                                                  .descrizioneModello
                                                              )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "margin-top": "10px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v("STAGIONE: "),
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.distinta
                                                                .idStagione
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      _vm._v("COLORE: "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.distinta
                                                              .idColore
                                                          ) +
                                                            " - " +
                                                            _vm._s(
                                                              _vm.distinta
                                                                .descrizioneColore
                                                            )
                                                        ),
                                                      ]),
                                                    ]),
                                                    _c("div", [
                                                      _vm._v("LINEA VENDITA: "),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.distinta
                                                              .lineaVenditaDescrizione
                                                          ) +
                                                            " (" +
                                                            _vm._s(
                                                              _vm.distinta
                                                                .lineaVenditaCodice
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]),
                                                    ]),
                                                    _c("div", [
                                                      _vm._v(
                                                        "ID: " +
                                                          _vm._s(
                                                            _vm.distinta.id
                                                          )
                                                      ),
                                                    ]),
                                                    _c("div", [
                                                      _vm._v(
                                                        "Avanzamento: " +
                                                          _vm._s(
                                                            _vm.distinta
                                                              .avanzamentoProduzione
                                                          )
                                                      ),
                                                    ]),
                                                    _vm.distinta.draft
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              position:
                                                                "absolute",
                                                              right: "20px",
                                                              bottom: "20px",
                                                            },
                                                            attrs: {
                                                              title:
                                                                "Distinta in DRAFT",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  "x-large": "",
                                                                  color:
                                                                    "primary",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-cloud-sync"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs10: "", "offset-xs1": "" } },
                                  [
                                    _c(
                                      "v-card-title",
                                      [
                                        _c("h2", [_vm._v("Righe distinta")]),
                                        _c("v-spacer"),
                                        _vm.$store.getters.isUserAdmin
                                          ? _c("v-switch", {
                                              attrs: {
                                                inset: "",
                                                label:
                                                  "Modalità validazione consumi",
                                              },
                                              model: {
                                                value:
                                                  _vm.modoValidazioneConsumi,
                                                callback: function ($$v) {
                                                  _vm.modoValidazioneConsumi =
                                                    $$v
                                                },
                                                expression:
                                                  "modoValidazioneConsumi",
                                              },
                                            })
                                          : _c("v-switch", {
                                              attrs: {
                                                "data-test":
                                                  "switch-comunicazione-consumi",
                                                inset: "",
                                                label:
                                                  "Modalità comunicazione consumi",
                                              },
                                              model: {
                                                value: _vm.modoInvioConsumi,
                                                callback: function ($$v) {
                                                  _vm.modoInvioConsumi = $$v
                                                },
                                                expression: "modoInvioConsumi",
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                    _vm.modoVisualizzazione
                                      ? _c("RigheDistintaList")
                                      : _vm._e(),
                                    _vm.modoInvioConsumi
                                      ? _c(
                                          "RigheDistintaComunicazioneConsumi",
                                          {
                                            attrs: {
                                              idDistinta: _vm.distinta.id,
                                            },
                                          }
                                        )
                                      : _vm._e(),
                                    _vm.modoValidazioneConsumi
                                      ? _c("RigheDistintaValidazioneConsumi")
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ])
                    : _c("div", [
                        _vm._v(" OPPPSSS... Nessun dato da visualizzare. "),
                      ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }